import {useEffect, useState} from "react";
import {getMenus, updateMenu} from "../api/api";
import {useNavigate} from "react-router";
import {useApp} from "../Contex";

export default function Menues(){
    const [menus, setMenues] = useState([]);
    const navigate = useNavigate();
    const { refresh, permissions: { write } } = useApp();


    function fetchData() {
        getMenus().then((ret) => {
            if (ret.ok) {
                setMenues(ret.data)
            }
        })
    }

    useEffect(() => {
        fetchData();
    },[refresh])

    const toggleHidden = (menu) => {
        let sort = +menu.sort;
        if(sort < 900){
            if(sort > 99){
                sort = 900;
            }else{
                sort = sort + 900;
            }
        }else{
            sort = sort - 900;
        }
        menu.sort = sort.toString();
        updateMenu(menu.mnuid, menu).then((ret)=>{
            if(ret.ok){
                fetchData()
            }
        })
    };


    const MenuItem = ({menu, index}) => {
        const hidden = menu.sort > 899;
        return(
            <div className={`card mb-2 p-2 bg-light d-flex justify-content-between flex-row ${hidden && 'bg-danger-subtle'}`}>
                <div>
                    <p className="fs-5 fw-bold mb-0">{menu.text.toSwe()}</p>
                    {!hidden && <p className="mb-0">Sortering: {menu.sort}</p>}
                </div>
                <div className="d-flex gap-2 align-items-start">
                    <button className="btn btn-outline-secondary" onClick={()=>{navigate(menu.gid)}}>
                        <i className="bi bi-pencil-square"></i>
                    </button>
                    {write &&
                    <button className={`btn ${hidden ? 'btn-outline-danger' : 'btn-outline-success'}`} onClick={()=>{toggleHidden(menu)}}>
                        <i className={`bi ${hidden ? 'bi-eye-slash' : 'bi-eye'}`} ></i>
                    </button>
                    }
                </div>
            </div>
        )
    }

    return (
        <div>
            <h1>Menyer</h1>
            {menus?.map((menu, index) => {
                return (
                    <MenuItem menu={menu} index={index} key={menu.mnuid}/>
                )
            })}
        </div>

    )
}
